var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{domProps:{"value":_vm.$route.query.text},on:{"change":_vm.onChangeText}}),_c('pre',[_vm._v(_vm._s(_vm.$route.query.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }